import * as React from 'react';
import { Box } from '~shared/components/Box';
import { UseIconProps, useIcon } from '../../useIcon';
import { IconShortAnswerSvg } from './IconShortAnswerSvg';

export type IconShortAnswerProps = UseIconProps;

export function IconShortAnswer(props: IconShortAnswerProps) {
  const iconProps = useIcon({ size: 'micro', ...props });
  return <Box tagName={IconShortAnswerSvg} {...iconProps} />;
}
